import blue from '../colors/blue';

export default {
  // Colors
  // The colours below are taken from the UI stylesheet. If you find you need a colour that doesn't
  // exist here, it's likely the design should be updated to match an use color, or the color needs
  // to be added to the stylesheet. Please speak to a designer first before adding here and
  // PLEASE DO NOT JUST ADD COLOURS BELOW BECAUSE IT'S IN A DESIGN :)

  BLACK: '#000000',
  WHITE: '#ffffff',
  GREEN: '#26762c',
  CARD: {
    BORDER: '#c6c6c6',
  },
  TRANSPARENT: '#ffffff99',
  TRANSLUCENT: '#ffffffcc',
  COMPLETE_TRANSPARENT: 'transparent',
  CULTURED: '#f4f4f4',
  GAINSBORO: '#dedede',
  ALERT_BACKGROUND: '#00000088',
  BRAND: {
    PRIMARY: '#4b9fdd',
    BOYS: '#e76829',
    GIRLS: '#ce43a6',
  },

  PRIMARY: {
    DARK: '#1a1a1a',
    GRAY: '#9b9b9b',
    DARKISHGRAY: '#636363',
    LIGHTGRAY: '#d8d8d8',
    LIGHTERGRAY: '#d9d9d9',
    LIGHTPALEGRAY: '#d2d2d2',
    DARKERGRAY: '#545454',
    PALEGRAY: '#f3f3f3',
    PALEBLUE: '#ebf7ff',
    DARKBLUE: '#162f42',
    BLUE: '#2e6a91',
    NAVY: '#24465e',
    GREEN: '#7dc24c',
    COLOR1: '#edf5fb',
    COLOR2: '#dbebf8',
    COLOR3: '#3b7cab',
    COLOR4: '#ffe700',
    PURPLE: '#beb3ff',
    LIGHTBLUE: '#21a9e2',
    GYMORANGE: '#f7971f',
    GRAY100: '#F3F3F3',
    YELLOW: '#faff03',
    RED: '#E93223',
  },
  TEXT: {
    DARK: '#1a1a1a',
    DARKGRAY: '#575757',
    LIGHTGRAY: '#d8d8d8',
    GRAY: '#9b9b9b',
    DARKERGRAY: '#595959',
    LIGHTERGRAY: '#e3e3e3',
    DARKBLUE: '#162f42',
    BLUE: '#2e6a91',
    DARKERBLUE: '#439ad4',
    RED: '#c84747',
    PINK: '#e19999',
    GREEN: '#7dc24c',
    PALEGRAY: '#f9f9f9',
    ORANGE: '#f18f28',
    DARKPINK: '#e2499a',
    LIGHTBLUE: '#00a7e0',
    BRANDGRAY: '#737373',
    GAINSBORO: '#cccccc',
  },
  PROMO: {
    FUCHSIA: '#ff3db4',
    PURPLE: '#b976cc',
    YELLOW: '#F6D343',
    RED: '#ED0505',
    ORANGE: '#F06D22',
    BLUE: '#3C7FB0',
    PINK: '#e2499a',
    PLCCBLUE: '#018cc9',
    PLCCBLUELIGHT: '#44b8e7',
  },
  BUTTON_HOVER: 'rgba(24, 24, 24, 0.8)',
  COUNT_ICON_DISABLE: 'rgba(0, 0, 0, 0.3)',
  EMPTY_CART_BOX: 'rgba(0, 0, 0, 0.07)',
  NEWDESIGN_BOX_SHADOW_1: 'rgba(0, 0, 0, 0.25)',
  NEWDESIGN_BOX_SHADOW_2: 'rgba(37, 79, 110, 0.2)',
  NEWDESIGN_BOX_SHADOW_3: 'rgba(0, 0, 0, 0.12)',
  NEWDESIGN_BOX_SHADOW_4: 'rgba(0, 0, 0, 0.16)',
  NEWDESIGN_BOX_SHADOW_5: 'rgba(0, 0, 0, 0.1);',
  MODAL_OVERLAY: 'rgba(0, 0, 0, 0.6)',
  GHOST_OVERLAY: 'rgba(255, 255, 255, 0.9)',
  BOX_SHADOW_LIGHT: 'rgba(0, 0, 0, 0.1)',
  WHITE_ALPHA: 'rgba(255, 255, 255, 0.88)',
  DISABLED_BG: 'rgba(239, 239, 239, 0.3)',
  BORDER_ALPHA: 'rgba(170, 170, 170, 0.5)',
  BUTTON: {
    WHITE: {
      NORMAL: '#ffffff',
      BORDER: '#979797',
      HOVER: '#f3f3f3',
      FOCUS: '#d8d8d8',
      ALT_HOVER: '#f2f9fe',
      ALT_FOCUS: '#e2ecf3',
      TEXT: '#4a4a4a',
    },
    BLUE: {
      NORMAL: '#2e6a91',
      BORDER: '#2e6a91',
      HOVER: '#1f4862',
      FOCUS: '#1f4862',
      ALT_HOVER: '#1f4862',
      ALT_FOCUS: '#1f4862',
      TEXT: '#fff',
      NEW_FILTER_BTN: '#254f6e',
      LEFT_FILTERS_BTN: '#005d95',
      ALERT_OPTIONS: '#007AFF',
    },
    RED: {
      NORMAL: '#ffffff',
      BORDER: '#c84747',
      HOVER: '#f3d7d7',
      FOCUS: '#e19999',
      ALT_HOVER: '#e19999',
      ALT_FOCUS: '#e19999',
      TEXT: '#c84747',
    },
    YELLOW: {
      NORMAL: '#FAFF03',
      BORDER: '#FAFF03',
      HOVER: '#FAFF03',
      FOCUS: '#FAFF03',
      ALT_HOVER: '#FAFF03',
      ALT_FOCUS: '#FAFF03',
      TEXT: '#000000',
    },
    BLACK: {
      NORMAL: '#1a1a1a',
      BORDER: '#1a1a1a',
      HOVER: '#595959',
      FOCUS: '#595959',
      ALT_HOVER: '#ffffff',
      ALT_FOCUS: '#ffffff',
      TEXT: '#ffffff',
    },
    SNJ_PRIMARY: {
      NORMAL: '#beb3ff',
      BORDER: '#beb3ff',
      HOVER: '#beb3ff',
      FOCUS: '#beb3ff',
      ALT_HOVER: '#beb3ff',
      ALT_FOCUS: '#beb3ff',
      TEXT: '#000000',
      BORDER_VAL: 'transparent',
      BG_IMAGE: 'linear-gradient(to right,#C1B3FE,#C1B3FE,#C1B3FE,#DFB3FE,#FFB3DF,#FFB2C0,#FFD9B4)',
      BG_SIZE: '400% 50%',
      BG_POSITION: '100% 0%',
      HOVER_TEXT: '#000000',
      HOVER_BORDER: 'none',
      TRANSITION: 'all .4s ease-in-out',
    },
    SNJ_SECONDARY: {
      NORMAL: '#ffffff',
      BORDER: '#7247b5',
      HOVER: '#ffffff',
      FOCUS: '#ffffff',
      ALT_HOVER: '#000000',
      ALT_FOCUS: '#000000',
      TEXT: '#7247b5',
      BG_IMAGE: 'linear-gradient(147deg,#fff,#fff,#fff,#C1B3FE,#DFB3FE,#FFB3DF,#FFB2C0,#FFD9B4)',
      BG_SIZE: '400% 50%',
      BG_POSITION: '100% 0%',
      HOVER_TEXT: '#000000',
      HOVER_BORDER: 'none',
      HOVER_TRANS: 'transparent',
      HOVER_BG_SIZE: '170%',
      TRANSITION: 'all .4s ease-in-out',
    },
    SNJ_HP_PRIMARY: {
      NORMAL: '#faff03',
      BORDER: '#000000',
      HOVER: '#faff03',
      FOCUS: '#faff03',
      BORDER_VAL: 'transparent',
      ALT_HOVER: '#000000',
      ALT_FOCUS: '#000000',
      TEXT: '#000000',
    },
    SNJ_HP_SECONDARY: {
      NORMAL: '#ffffff',
      BORDER: '#7247b5',
      HOVER: '#ffffff',
      FOCUS: '#ffffff',
      ALT_HOVER: '#000000',
      ALT_FOCUS: '#000000',
      TEXT: '#7247b5',
      BG_IMAGE: 'linear-gradient(147deg,#fff,#fff,#fff,#C1B3FE,#DFB3FE,#FFB3DF,#FFB2C0,#FFD9B4)',
      BG_SIZE: '400% 50%',
      BG_POSITION: '100% 0%',
      HOVER_TEXT: '#000000',
      HOVER_BORDER: 'none',
      HOVER_TRANS: 'transparent',
      TRANSITION: 'all .3s ease-in-out',
      HOVER_BG_SIZE: '170%',
    },
    SNJ_HP_TERTIARY: {
      NORMAL: '#ffffff',
      BG_IMAGE:
        'linear-gradient(147deg, #c1b3fe 2%, #dfb3fe 27%, #ffb3df 57%, #ffb2c0 74%, #ffd9b4 91%)',
      HOVER: '#beb3ff',
      HOVER_TEXT: '#000000',
      HOVER_BORDER: 'none',
      HOVER_TRANS: 'transparent',
      TRANSITION: 'none',
      HOVER_BG_POSITION: '0% 0%',
    },
    PJP_PRIMARY: {
      NORMAL: '#fff',
      BORDER: '#0023b2',
      HOVER: '#0133FF',
      FOCUS: '#3850AF',
      TEXT: '#0023b2',
      HOVER_TEXT: '#fff',
      HOVER_BORDER: 'none',
      HOVER_TRANS: 'transparent',
      HOVER_BG_POSITION: '0% 0%',
    },
    PJP_SECONDARY: {
      NORMAL: '#0023b2',
      BORDER: '#0023b2',
      HOVER: '#0023b2', // To-Do
      FOCUS: '#0023b2', // To-Do
      TEXT: '#fff',
      HOVER_TRANS: 'transparent',
      HOVER_BG_POSITION: '0% 0%',
    },
  },

  ANCHOR: {
    PRIMARY: '#1a1a1a',
    SECONDARY: '#2e6a91',
    TERTIARY: '#c84747',
    GRAYED: '#9b9b9b',
    LIGHT_GRAY: '#595959',
  },
  TEXTBOX: {
    COLOR: '#1a1a1a',
    BACKGROUND: '#f2f2f2',
    FOCUS_BORDER: '#439ad4',
    ERROR_BORDER: '#c84747',
    SUCCESS_BORDER: '#6dc927',
  },
  ACCORDION: {
    INACTIVE_HEADER: '#e5e5e5',
    ACTIVE_HEADER: '#f7f7f7',
    COLLAPSE_EXPAND_ICON: '#9b9b9b',
    TEXT: '#1a1a1a',
  },
  FOOTER: {
    DIVIDER: '#c3c3c3',
  },
  NOTIFICATION: {
    SUCCESS: '#26762c',
    ERROR: '#c8102e',
    ERROR_BACKGROUND: '#f4dcdc',
  },
  BORDER: {
    NORMAL: '#979797',
    BLUE: '#2e6a91',
    GRAY: '#e3e3e3',
    LIGHTGRAY: '#e8e8e8',
  },
  CHECKBOX: {
    BORDER: '#575757',
    CHECKED_BORDER: '#1a1a1a',
    TICK_COLOR: '#fff',
  },
  NAVIGATION: {
    CIRCULAR_BORDER: '#6b6b6b',
    L1_BACKGROUND: '#f6f6f6',
    GREEN: '#93DE6E',
    YELLOW: '#FFE600',
  },
  RECOMMENDATION_BANNER: {
    PLP: '#e8e4db',
  },
  REWARDS: {
    NON_PLCC: '#F7971F',
    PLACE_CASH: '#7EE475',
    PLACE_CASH_BACKGROUND: '#ECFFEA',
    PLCC: '#00A7E0',
  },
  REWARDS_OVERLAY: 'rgba(25, 25, 25, 0.7)',
  PRODUCT_TILE_SHADOW: 'rgba(146, 146, 146,.5)',
  VENMO: '#3d95ce',
  WARNING_BACKGROUND: '#f3f0f0',
  CUSTOM: {
    ORDER_SUCCESS: '#137b17',
  },
  BORDER_WARNING_YELLOW: '#ffab00',
  DEFAULT_ACCENT_GYM: '#f7971f',
  DEFAULT_ACCENT_TCP: '#c0e9f9',
  DEFAULT_ACCENT_PJP: '#51B4BF',
  PLCC_BACKGROUND: '#00a7e0',
  HP_BG_COLOR: '#efefef',
  AFTERPAY: {
    MINT: '#b2fce4',
  },
  SNJ_NAV: ['#89f1f4', '#89c9ff', '#91aaff', '#cb80ff', '#ff92d0', '#ffa4a9', '#ffc58b'],
  TRANS_BLACK: 'rgba(0, 0, 0, 0)',
  NON_PLCC_OVERLAY: '#FDECD6',
  PLCC_OVERLAY: '#ccedf8',
  PRIMARY_BUTTON_BORDER_COLOR: '#4b9fdd',
  PRIMARY_BUTTON_COLOR: '#162f42',
  PRIMARY_TEXT_COLOR: '#ffffff',
  NOTIFICATION_PROMPT_WRAPPER: '#21a9e2',
  ORDER_STATUS_WRAPPER: '#162f42',
  ITEM_COUNT_WRAPPER: '#254f6e',
  TAP_TO_JOIN_BG_COLOR: blue[900],
  DIVIDER: '#D8D8D8',
  PLP_SIDEBAR_SUBCATEGORY_BORDER: blue[500],
  BOSS_BOPIS_SHIPPING_CONTAINER: '#e3e3e3',
  PLP_SIDE_NAVBAR_SUBHEADER_BORDER: blue[500],
  TRANSLUCENT_BG_COLOR: 'rgba(255, 255, 255, 0.8)',
  INFLUENCER_BADGE_BACKGROUND: 'rgba(26, 26, 26, 0.6)',
  FAV_ICON_COLOR: '#f2bf2f',
};
